import script from "./CreateAnnotationSet.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAnnotationSet.vue?vue&type=script&setup=true&lang=js"

import "./CreateAnnotationSet.vue?vue&type=style&index=0&id=208d5aef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208d5aef"]])

export default __exports__